import { createApp, createVNode } from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "element-plus/dist/index.css";
import * as Icons from "@element-plus/icons-vue";

// 创建Icon组件-动态
const Icon = (props: { icon: string }) => {
  const { icon } = props;
  return createVNode(Icons[icon as keyof typeof Icons]);
};

createApp(App).use(store).use(router).component("Icon", Icon).mount("#app");
